let loadPromise = null;

// Sibling of checkoutLoader.js but for the <mcs-checkout-subscription> web
// component. Prod: fetch Vite manifest at VUE_APP_CHECKOUT_SUBSCRIPTION_CDN_BASE
// and resolve the hashed entry. Dev: load directly from VUE_APP_CHECKOUT_SUBSCRIPTION_URL.
async function resolveSubscriptionCheckoutScriptUrl(inDevEnv) {
  if (inDevEnv) {
    return process.env.VUE_APP_CHECKOUT_SUBSCRIPTION_URL;
  }
  const base = process.env.VUE_APP_CHECKOUT_SUBSCRIPTION_CDN_BASE;
  const res = await fetch(`${base}/.vite/manifest.json`);
  if (!res.ok) throw new Error(`subscription checkout manifest fetch failed: ${res.status}`);
  const manifest = await res.json();
  const entry = Object.values(manifest).find((e) => e && e.isEntry);
  if (!entry || !entry.file) throw new Error('subscription checkout manifest has no entry');
  return `${base}/${entry.file}`;
}

export function loadSubscriptionCheckoutScript({ inDevEnv } = {}) {
  if (loadPromise) return loadPromise;
  if (customElements.get('mcs-checkout-subscription')) {
    loadPromise = Promise.resolve();
    return loadPromise;
  }

  loadPromise = (async () => {
    const url = await resolveSubscriptionCheckoutScriptUrl(inDevEnv);
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.setAttribute('data-checkout-subscription-app', '');
      script.src = url;
      if (inDevEnv) {
        script.type = 'module';
        script.crossOrigin = 'anonymous';
      }
      script.onload = () => resolve();
      script.onerror = () => {
        loadPromise = null;
        reject(
          new Error(
            'Failed to load subscription checkout script (is `npm run dev:all` running in MyCreativeShop.CheckoutSubscriptionApp?)'
          )
        );
      };
      document.head.appendChild(script);
    });
  })();
  loadPromise.catch(() => {
    loadPromise = null;
  });
  return loadPromise;
}
